// extracted by mini-css-extract-plugin
module.exports = {"userContainer":"styles_userContainer__N_Nv9","userContent":"styles_userContent__y_LDP","userAvatar":"styles_userAvatar__agwX2","userName":"styles_userName__iZjOg"};